
const isProduction = process.env.NODE_ENV === 'production';

// Set base API URL depending on environment
export const API_BASE_URL = isProduction
  ? 'https://onelogin.bsparksoftwaretechnologies.com/backend/api'
  : 'http://localhost/onelogin/backend/api';

// ✅ Base for uploaded files (one level up from /api)
export const UPLOADS_BASE_URL = isProduction
  ? 'https://admin.bsparksoftwaretechnologies.com/server/uploads'
  : 'http://localhost/onelogin/backend/api/uploads';

export const API = {
  BASE: API_BASE_URL,
  REGISTER: `${API_BASE_URL}/register.php`,
  LOGIN: `${API_BASE_URL}/login.php`,
  ADD_PAGE: `${API_BASE_URL}/add-page.php`,
  ALL_PAGES: `${API_BASE_URL}/get-all-pages.php`,
  DELETE_PAGE: `${API_BASE_URL}/delete-page.php`,
  GET_COURSES: `${API_BASE_URL}/get-courses.php`,
  GET_PARENT_PAGES: `${API_BASE_URL}/get-parent-pages.php`,
  GET_PAGE_BY_ID: `${API_BASE_URL}/get-page.php`,
  UPDATE_PAGE: `${API_BASE_URL}/update-page.php`,
  GRANT_ACCESS: `${API_BASE_URL}/grant-access.php`,
  GET_PAGE_TREE_BY_ROOT: `${API_BASE_URL}/get_page_tree_by_root.php`,
  GET_STUDENTS: `${API_BASE_URL}/get-students.php`,
  UPLOAD_IMAGE: `${API_BASE_URL}/upload-image.php`,
  GET_ALL_PAGES: `${API_BASE_URL}/get-all-pages.php`,
  GET_STUDENT_PROFILE: `${API_BASE_URL}/get_student_profile.php`,
  UPLOAD_VIDEO: `${API_BASE_URL}/upload-video.php`,
  GET_STUDENT_BY_ID: `${API_BASE_URL}/get-student-by-id.php`,

  // Profile APIs
  GET_STUDENT_PROFILE_BY_EMAIL: `${API_BASE_URL}/profile/get_student_profile.php`,
  UPDATE_STUDENT: `${API_BASE_URL}/profile/update_profile.php`,
  GET_EMPLOYEE_PROFILE_BY_EMAIL: `${API_BASE_URL}/profile/get_employee_profile.php`,
  UPDATE_EMPLOYEE: `${API_BASE_URL}/profile/update_employee_profile.php`,

  // ✅ Uploads base URL — works in both local and production
  UPLOADS: UPLOADS_BASE_URL,

  // Meeting APIs
  CREATE_ZOHO_MEETING_ENDPOINT: `${API_BASE_URL}/meetings/create-meeting.php`,
  GET_ZOHO_MEETINGS_ENDPOINT: `${API_BASE_URL}/meetings/get-meetings.php`,
  DELETE_ZOHO_MEETING_ENDPOINT: `${API_BASE_URL}/meetings/delete-meeting.php`,
  GET_SINGLE_MEETING_ENDPOINT: `${API_BASE_URL}/meetings/get-single-meeting.php`,
  UPDATE_ZOHO_MEETING_ENDPOINT: `${API_BASE_URL}/meetings/update-meeting.php`,
  GET_USER_MEETINGS_ENDPOINT: `${API_BASE_URL}/meetings/get-user-meetings.php`,
  GET_STUDENTS_ENDPOINT: `${API_BASE_URL}/meetings/get-students.php`,
  GET_RECORDING_ENDPOINT: `${API_BASE_URL}/meetings/get-recording.php`,
  SYNC_RECORDINGS_ENDPOINT: `${API_BASE_URL}/meetings/sync-recordings.php`,
  SET_RECORDING_ENDPOINT: `${API_BASE_URL}/meetings/set-recording.php`,
  GET_NOTIFICATIONS_ENDPOINT: `${API_BASE_URL}/meetings/get-notifications.php`,

  // Forgot Password API
  FORGOT_PASSWORD: `${API_BASE_URL}/forgot_password.php`,
};